.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.icon {
  font-size: 5rem;
  stroke-width: 0.75;
}

.message {
  font-size: 1.5rem;
  margin: 0;
  text-align: center;
}
